export default __webpack_public_path__ + "static/figure-1-b900f15c0cfa4a851ed51e64f058b16a.webp";